<template>
    <div class="pop-get" :class="`pop-get-${store.popData.level_num}`">
        <div class="pop-bg"></div>
        <div class="pop-get-content">
            <div class="title g-flex-center-center">
                <div class="pop-title-icon"></div>
                <p class="title-text qm-special-font">恭喜获得</p>
                <div class="pop-title-icon title-right"></div>
                <div class="title-bg pop-title-bg"></div>
            </div>
            <p class="award-desc">{{ store.popData.reward_desc }}</p>
            <p class="award-desc award-desc2" v-if="store.popData.reward_second_desc">{{ store.popData.reward_second_desc }}</p>
            <p class="award-desc award-desc2 award-desc3" v-if="store.popData.reward_third_desc">{{ store.popData.reward_third_desc }}</p>
            <div class="award" :class="{ 'award-top': store.popData.reward_second_desc }">
                <div class="award-img" :class="{ 'award-img-gourd': store.popData.isGourd }">
                    <div class="award-img-bg" :class="store.popData.isGourd ? 'pop-award-bg' : 'pop-award-bg2'"></div>
                    <img class="award-img-item" :src="store.popData.reward_img_url" alt="" />
                    <img class="award-img-avatar" :src="store.indexData.user_info.avatar" alt="" />
                </div>
                <p class="award-name" v-if="store.popData.isGourd">{{ store.popData.reward_title }}</p>
                <div class="award-btn button-1 g-flex-center-center" @click="onClick">
                    <p class="award-btn-text">{{ store.popData.reward_btn_title }}</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, computed, getCurrentInstance } from 'vue';
import { useStore } from '@/store';
import { jsbSupportMap, schemaSupportMap, schemaSingle } from '@q-front-npm/jsbridge';
const instance = getCurrentInstance();
const store = useStore();

const onClick = () => {
    if (store.popData.isGourd) {
        store.setPopStatus('get', false);
        store.setPopStatus('view', true);
        return;
    }
    const url = store.popData.reward_btn_url;
    if (!url) {
        store.setPopStatus('get', false);
        return;
    }
    // 是否是勋章， 低版本提示升级
    if (url.indexOf('medal_center') > -1) {
        if (schemaSupportMap.medal_center) {
            schemaSingle.openSchema(url);
        } else {
            instance!.proxy.$toast('请升级至最新版本');
        }
        return;
    }
    schemaSingle.openSchema(url);
};
</script>
<style lang="scss" scoped>
.pop-get {
    position: relative;
    width: 600px;
    margin: 0 auto;
    .pop-get-content {
        position: absolute;
        top: 78px;
        left: 0;
        right: 0;
        bottom: 0;
    }
    &-2,
    &-6 {
        .award-img-avatar {
            display: block;
        }
    }
}

.title {
    position: relative;
    &-text {
        font-size: 48px;
        color: #276ad1;
        line-height: 50px;
        padding: 0 16px;
        position: relative;
        z-index: 2;
    }
    &-bg {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 4px;
        margin: auto;
    }
    &-right {
        transform: rotate(180deg);
    }
}

.award {
    &-top {
        margin-top: -30px;
    }
    &-desc {
        text-align: center;
        margin-top: 10px;
        font-size: 24px;
        color: #5174b4;
        line-height: 34px;
        padding: 0 50px;

        &2 {
            margin-top: 0;
        }
        &3 {
            font-size: 20px;
            opacity: 0.6;
        }
    }
    &-img {
        width: 240px;
        height: 240px;
        margin: 80px auto 0;
        position: relative;
        &-gourd {
            width: 266px;
            height: 266px;
            margin: 48px auto 0;
        }
        &-item {
            width: 100%;
            height: 100%;
            position: relative;
            z-index: 3;
        }
        &-bg {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
        &-avatar {
            width: 194px;
            height: 194px;
            position: absolute;
            top: 50%;
            left: 50%;
            border-radius: 50%;
            transform: translate(-50%, -50%);
            display: none;
        }
    }
    &-name {
        margin-top: 10px;
        font-size: 24px;
        color: rgba(81, 116, 180, 0.8);
        line-height: 34px;
        text-align: center;
    }
    &-btn {
        position: relative;
        z-index: 2;
        margin: 20px auto 0;

        &-text {
            font-weight: bold;
            font-size: 28px;
            color: #a9582f;
            line-height: 1;
        }
    }
}
</style>
